<template>
  <common-dialog ref="dialog" width="100%" title="打印快递单" id-key="id" :data="data" @opened="onOpened"
    @create-opened="onCreateOpened" @edit-opened="onEditOpened" :form-rules="rules" :save-func="saveDataFunc"
    reset-on-close @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <pdd-print style="min-height: 700px;"></pdd-print>
    </template>
    <template slot="footer">
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';
import pddPrint from "@/components/common/pddPrint"

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    pddPrint
  },
  data() {
    return {
      api: require('@/api/ali/malladdresses').default,
      logisticsApi: require('@/api/ali/logistics').default,
      data: {
        id: 0,
        wpCode: "", //快递公司Code
        address: "",
        shopId: 0, //店铺id
        shopName: "大龙猫杂货店", //店铺名称
        senderAddress: {
          country: "",
          province: "",
          city: "",
          district: "",
          street: "",
          detailAddress: "",
          postalCode: "",
          fullName: "",
          mobilePhone: "",
          dataMasking: false, //数据脱敏
        },
      },
      rules: {
        wpCode: [{ required: true, message: '请选择快递公司' }],
        'senderAddress.fullName': [{ required: true, message: '寄件人不能为空' }],
        'senderAddress.mobilePhone': [{ required: true, message: '手机号码不能为空' }],
        address: [{ required: true, message: '请选择发货地址' }],
      },
      companiesList: [],
      senderAddresses: [],
    };
  },
  mounted() { },
  methods: {
    onOpened() {

    },
    onCreateOpened() {

    },
    onEditOpened() {

    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.postSender(this.data).then(res => {
          if (res) {
            resolve({ Code: 1, Msg: res.errorMessage })
          } else {
            resolve({ Code: 0, Msg: null })
          }
        })
      })
    },
  },
};
</script>
